'use strict';

var React = require('react/addons');
var Reflux = require('reflux');

var _require = require('jsBezier');

var jsBezier = _require.jsBezier;

/* Components */
var Curve = require('components/graphics/curve');

/* Stores */
var ModuleConnectionStore = require('stores/module-connection');
var ModuleStore = require('stores/module');
var ProjectStore = require('stores/project');

var Connections = React.createClass({
  displayName: 'Connections',

  mixins: [Reflux.listenTo(ModuleConnectionStore, 'onModuleConnectionStoreChange')],

  onModuleConnectionStoreChange: function onModuleConnectionStoreChange(connections) {
    var dragging = ModuleConnectionStore.dragging;
    var position = ModuleConnectionStore.position;
    var outputModule = ModuleConnectionStore.outputModule;
    var outputName = ModuleConnectionStore.outputName;
    var outputIndex = ModuleConnectionStore.outputIndex;
    var inputModule = ModuleConnectionStore.inputModule;
    var inputName = ModuleConnectionStore.inputName;
    var inputIndex = ModuleConnectionStore.inputIndex;

    this.setState({
      connections: connections,
      dragging: dragging, position: position,
      outputModule: outputModule, outputIndex: outputIndex,
      inputModule: inputModule, inputIndex: inputIndex
    });
  },

  getInitialState: function getInitialState() {
    return {
      connections: []
    };
  },

  render: function render() {
    var component = this;

    var _component$state = component.state;
    var connections = _component$state.connections;
    var dragging = _component$state.dragging;
    var position = _component$state.position;

    var projectOffset = ProjectStore.position;

    var connectionNodes = connections.map(function (connection) {

      var outputModule = ModuleStore.find(connection.output.instance);
      var inputModule = ModuleStore.find(connection.input.instance);

      if (!outputModule || !inputModule) {
        return;
      }

      var outputIndex = 0;
      outputModule.moduleType.outputs.find(function (output) {
        outputIndex++;
        return output.name === connection.output.name;
      });

      var inputIndex = 0;
      inputModule.moduleType.inputs.find(function (input) {
        inputIndex++;
        return input.name === connection.input.name;
      });

      var outputOffset = 36 + outputIndex * 20;
      var inputOffset = 36 + inputIndex * 20;

      var start = { x: outputModule.position.x + 210 + projectOffset.x, y: outputModule.position.y + outputOffset + projectOffset.y };
      var end = { x: inputModule.position.x + projectOffset.x, y: inputModule.position.y + inputOffset + projectOffset.y };
      var color = connection.selected ? '#72B85D' : '#BABABA';
      var width = '1';

      return React.createElement(Curve, { key: connection.id, id: connection.id, start: start, end: end, color: color, strokeWidth: width });
    }).filter(function (node) {
      return node;
    });

    if (dragging && position) {

      var outputModule = component.state.outputModule;
      var outputIndex = component.state.outputIndex;
      var outputOffset = 36 + outputIndex * 20;

      var start = { x: outputModule.position.x + 210 + projectOffset.x, y: outputModule.position.y + outputOffset + projectOffset.y };
      var end = { x: position.x, y: position.y };

      connectionNodes.push(React.createElement(Curve, { key: 'new', start: start, end: end, color: '#72B85D', strokeWidth: '1' }));
    }

    return React.createElement(
      'div',
      { className: 'module-connections-component', onClick: component._onClick.bind(null, connectionNodes) },
      connectionNodes
    );
  },

  _onClick: function _onClick(curves, evt) {
    var component = this;

    if (!component.props.onClick) {
      return;
    }

    var point = { x: evt.clientX, y: evt.clientY };

    var closestCurve = { distance: 10 };

    curves.forEach(function (node) {
      var _node$props = node.props;
      var id = _node$props.id;
      var bezier = _node$props.bezier;

      var distance = jsBezier.distanceFromCurve(point, bezier).distance;

      if (closestCurve.distance > distance) {
        closestCurve = { id: id, node: node, distance: distance };
      }
    });

    var _closestCurve = closestCurve;
    var id = _closestCurve.id;
    var ctrlKey = evt.ctrlKey;
    var metaKey = evt.metaKey;
    var altKey = evt.altKey;
    var shiftKey = evt.shiftKey;

    component.props.onClick(id, { ctrlKey: ctrlKey, metaKey: metaKey, altKey: altKey, shiftKey: shiftKey });
  }
});

module.exports = Connections;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/connections.js
 **/